"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditAnalysisMapper = exports.propertyTypeMapper = exports.transferMapper = exports.registrationTypeMapper = exports.mailMapper = exports.contractMapper = exports.paymentMethodMapper = exports.paymentMapper = void 0;
const payment_mapper_1 = require("./mapper/payment-mapper");
const payment_method_mapper_1 = require("./mapper/payment-method-mapper");
const contract_mapper_1 = require("./mapper/contract-mapper");
const mail_mapper_1 = require("./mapper/mail-mapper");
const registration_type_mapper_1 = require("./mapper/registration-type-mapper");
const transfer_mapper_1 = require("./mapper/transfer-mapper");
const property_type_mapper_1 = require("./mapper/property-type-mapper");
const credit_analysis_mapper_1 = require("./mapper/credit-analysis-mapper");
exports.paymentMapper = payment_mapper_1.default;
exports.paymentMethodMapper = payment_method_mapper_1.default;
exports.contractMapper = contract_mapper_1.default;
exports.mailMapper = mail_mapper_1.default;
exports.registrationTypeMapper = registration_type_mapper_1.default;
exports.transferMapper = transfer_mapper_1.default;
exports.propertyTypeMapper = property_type_mapper_1.default;
exports.creditAnalysisMapper = credit_analysis_mapper_1.default;
//# sourceMappingURL=index.js.map